const name = new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$');
export default name;


// WEBPACK FOOTER //
// ./src/common/reg/name.js